export interface Theme {
    updatedAt?: string; // DateTime string in ISO 8601 format
    logoUrl?: string; // Full URL to logo
    backgroundColor?: string; // color in #XXXXXX format
    backgroundImageUrl?: string;
    disableBottomLogo?: boolean;
    disablePoweredBy?: boolean;
    isDark?: boolean;
}

export const useLoaderConfig = (assetsEndpoint: string) => {
    const config = getThemeConfig();

    if (!config || (!config.logoUrl && !config.backgroundImageUrl)) {
        return null;
    }

    if (config.logoUrl) {
        const logoUrl = new URL(config.logoUrl);
        logoUrl.searchParams.set('_v', config.updatedAt || '');
        config.logoUrl = logoUrl.toString();
    }

    if (config.backgroundImageUrl) {
        const backgroundImageUrl = new URL(config.backgroundImageUrl);
        backgroundImageUrl.searchParams.set('_v', config.updatedAt || '');
        config.backgroundImageUrl = backgroundImageUrl.toString();
    }

    return config;
};

export const useCopyrightConfig = () => {
    const config = getThemeConfig();

    if (!config || !config.disablePoweredBy) {
        return null;
    }

    return config;
};

const getThemeConfig = (): Theme | null => {
    const urlParams = new URLSearchParams(window.location.search);
    const themeRaw = urlParams.get('theme'); // Base64 encoded theme config

    if (!themeRaw) return null;

    try {
        return JSON.parse(atob(themeRaw));
    } catch (e) {
        return null;
    }
};
